import React from 'react';
import { Card } from '../ui/Card';
import { motion } from 'framer-motion';
import { Ghost, MessageSquareX, Clock, Flame, Lock, CheckCircle } from 'lucide-react';
export function ProblemSolution() {
  return <section className="py-20 bg-gray-50" id="how-it-works" data-id="element-192">
      <div className="container mx-auto px-4" data-id="element-193">
        {/* The Problem */}
        <div className="mb-24" data-id="element-194">
          <div className="text-center mb-12" data-id="element-195">
            <h2 className="text-3xl font-bold mb-4" data-id="element-196">
              The "Situationship" Struggle
            </h2>
            <p className="text-xl text-muted-foreground" data-id="element-197">
              Vibes are good but nobody says what it is.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-198">
            {[{
            icon: MessageSquareX,
            title: 'Too Vague',
            desc: "Texting for 3 weeks with zero clarity on where it's going."
          }, {
            icon: Clock,
            title: 'Too Intense',
            desc: 'Committing to a full relationship before you even know them.'
          }, {
            icon: Ghost,
            title: 'Too Messy',
            desc: 'Ghosting happens because clarity feels awkward to ask for.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} data-id="element-199">
                <Card className="p-8 h-full hover:shadow-md transition-shadow" data-id="element-200">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6 text-red-600" data-id="element-201">
                    <item.icon className="w-6 h-6" data-id="element-202" />
                  </div>
                  <h3 className="text-xl font-bold mb-3" data-id="element-203">{item.title}</h3>
                  <p className="text-muted-foreground" data-id="element-204">{item.desc}</p>
                </Card>
              </motion.div>)}
          </div>
        </div>

        {/* The Solution */}
        <div data-id="element-205">
          <div className="text-center mb-16" data-id="element-206">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-207">
              FlingLink is a container.
            </h2>
            <p className="text-xl text-muted-foreground" data-id="element-208">
              It's not a relationship. It's an experiment.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-209">
            {/* Connecting Line (Desktop) */}
            <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-200 -z-10" data-id="element-210"></div>

            {[{
            icon: '🕯️',
            title: '1. Pick a Vibe',
            desc: 'Casual? Serious? Just testing? Set the intention upfront.'
          }, {
            icon: '🧠',
            title: '2. Set Boundaries',
            desc: 'Choose 2 hard limits. No guessing games.'
          }, {
            icon: '✅',
            title: '3. Day 7 Decision',
            desc: '2 mins a day. Then decide: Renew or Graduate.'
          }].map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="text-center bg-white p-8 rounded-3xl shadow-sm border border-gray-100 relative" data-id="element-211">
                <div className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center text-4xl mx-auto mb-6 border-4 border-white shadow-sm" data-id="element-212">
                  {step.icon}
                </div>
                <h3 className="text-2xl font-bold mb-3" data-id="element-213">{step.title}</h3>
                <p className="text-muted-foreground" data-id="element-214">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}